module.exports = __webpack_public_path__ + "img/656-fe3013.png";